class StickyHeader {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let  scrollPos = 0;

        // Prevent the sticky nav from being briefly visible on page load
        setTimeout(() => {
            self.elem.classList.add('is-active');
        }, 1000);

        window.addEventListener('scroll', function() {
            let position = (document.body.getBoundingClientRect()).top;

            if (position > scrollPos && position < -600) {
                self.elem.classList.add('is-visible');
            } else {
                self.elem.classList.remove('is-visible');
            }
            
            scrollPos = position;
        });
    }
}

export default StickyHeader;
